<section id="services">
    <div class="header-title">
      <h1 i18n="Services Title|Title for Services Page@@TitleServices">Services</h1>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 25 1440 200">
        <path fill="#ffffff" fill-opacity="1" d="M0,128L80,122.7C160,117,320,107,480,122.7C640,139,800,181,960,181.3C1120,181,1280,139,1360,117.3L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
      </svg>
    </div>
    <div class="contents slideanim">
      <div id="servicelist" [@enterCard]="services.length">
        <div class="card-container" *ngFor="let sv of services.slice().reverse()">
          <div class="icon-card">
            <span class="{{ sv.icon }}" aria-hidden="true"></span>
          </div>
          <div class="card">
            <div class="card-body">
              <h4>{{ sv.serviceTitle }}</h4>
              <div class="full" [innerHTML]="sv.fullText"></div>
            </div>
    
          </div>
        </div>
        
      </div>

    </div>

  </section>
